import React, { useContext } from 'react';
import "../../ui-styles/bottomSlider/BottomDetailsSlide.css";
import { LangCtx } from "../../lib/context";

const ConfirmDeleteModal = (props) => {
    const { l } = useContext(LangCtx);
    return (
        <div className={props.open ? "btmDtlSlider visible" : "btmDtlSlider"}>
            <div className="btmDtlPaper">
                <div className="btmDtlHeader">
                    <span className="hdrTxt">{props.title}</span>
                </div>
                <div className="btmDtlBdy">
                    <span className="summaryTxt">{l[props.subject]}</span>
                </div>
                <div className="hdrAction">
                    <div className="hdrActionBox">
                        <span className="hrActionTxt" onClick={props.handleCancel}>{l.cancel}</span>
                    </div>
                    <div className="hdrActionBox">
                        <span className="hrActionTxt" onClick={props.handleDelete}>{l.delete}</span>
                    </div>
                </div>
            </div>
        </div>
    )
}
export default ConfirmDeleteModal;